module.exports = __webpack_public_path__ + "static/media/20200921_155358.1d0e339e.jpg";